import LocalUserSettingsDelegate from './LocalUserSettingsDelegate.js'

class UserSettings {

  /**
   * 
   * @param {string} options.profile a string representing the user "type", eg "installer"
   * @param {Array} options.fallback an array of fallback configurations
   * @param {function} options.dispatch a redux dispatch function
   * @param {string} options.basePath a string for the base path UI rsrcs live under, eg "ui"
   * @param {string} options.userId the id of the logged in user for the ui
   * @param {string} options.projectId the id of the ui's project
   */
  constructor( options ) {
    this.delegate = options?.delegate || new LocalUserSettingsDelegate( options )
  }

  setDelegate( delegate ) {
    this.delegate = delegate
  }

  getScope( state, path, opts ) {
    return this.delegate?.getScope && this.delegate?.getScope( state, path, opts )
  }

  getProfileScope( state, profile, path, opts ) {
    return this.delegate?.getProfileScope && this.delegate?.getProfileScope( state, profile, path, opts )
  }

  addIntercept( path, fn ) {
    return this.delegate?.addIntercept && this.delegate.addIntercept( path, fn )
  }

  removeIntercept( path, fn ) {
    return this.delegate?.removeIntercept && this.delegate.removeIntercept( path, fn )
  }

  getIntercepts( path ) {
    return this.delegate?.getIntercepts && this.delegate.getIntercepts( path )
  }

  addDefault( path, fnOrObj ) {
    return this.delegate?.addDefault && this.delegate.addDefault( path, fnOrObj )
  }

  getDefault( path ) {
    return this.delegate?.getDefault && this.delegate.getDefault( path )
  }

  removeDefault( path ) {
    return this.delegate?.removeDefault && this.delegate.removeDefault( path )
  }

  // interface functions for current
  get( state, path, opts ) {
    return this.delegate?.get && this.delegate?.get( state, path, opts )
  }

  getProfile( state, profile, path, opts ) {
    return this.delegate?.getProfile && this.delegate?.getProfile( state, profile, path, opts )
  }

  set( path, value ) {
    return this.delegate?.set && this.delegate?.set( path, value )
  }

  reset( path ) {
    return this.delegate?.reset && this.delegate?.reset( path )
  }

  // current version stuff
  getVersion( state, path, version, opts ) {
    return this.delegate?.getVersion && this.delegate?.getVersion( state, path, version, opts )
  }

  getVersions( state, path, opts ) {
    return this.delegate?.getVersions && this.delegate?.getVersions( state, path, opts )
  }

  setVersion( path, version, value, opts ) {
    return this.delegate?.setVersion && this.delegate?.setVersion( path, version, value, opts )
  }

  renameVersion( path, oldVersionName, newVersionName, opts ) {
    return this.delegate?.renameVersion && this.delegate?.renameVersion( path, oldVersionName, newVersionName, opts )
  }

  resetVersion( path, version ) {
    return this.delegate?.resetVersion && this.delegate?.resetVersion( path, version )
  }
  // end current version stuff
  // end current

  // interface functions for setting a specific shared profile
  getSharedProfile( state, profile, path, opts ) {
    return this.delegate?.getSharedProfile && this.delegate?.getSharedProfile( state, profile, path, opts )
  }

  setSharedProfile( profile, path, value, opts ) {
    return this.delegate?.setSharedProfile && this.delegate?.setSharedProfile( profile, path, value, opts )
  }

  getSharedProfiles() {
    return this.delegate?.getSharedProfiles && this.delegate?.getSharedProfiles()
  }

  resetSharedProfile( profile, path, opts ) {
    return this.delegate?.resetSharedProfile && this.delegate?.resetSharedProfile( profile, path, opts )
  }
  // end interface functions for a specific profile

  // shared version stuff
  getSharedVersion( state, path, version, opts ) {
    return this.delegate?.getSharedVersion && this.delegate?.getSharedVersion( state, path, version, opts )
  }

  getSharedVersions( state, path, opts ) {
    return this.delegate?.getSharedVersions && this.delegate?.getSharedVersions( state, path, opts )
  }

  setSharedVersion( path, version, value, opts ) {
    return this.delegate?.setSharedVersion && this.delegate?.setSharedVersion( path, version, value, opts )
  }

  renameSharedVersion( path, oldVersionName, newVersionName, opts ) {
    return this.delegate?.renameSharedVersion && this.delegate?.renameSharedVersion( path, oldVersionName, newVersionName, opts )
  }

  resetSharedVersion( path, version ) {
    return this.delegate?.resetSharedVersion && this.delegate?.resetSharedVersion( path, version )
  }
  // end shared version stuff

  // interface functions for setting a user's specific profile
  getUserProfile( state, profile, path, opts ) {
    return this.delegate?.getUserProfile && this.delegate?.getUserProfile( state, profile, path, opts )
  }

  setUserProfile( profile, path, value ) {
    return this.delegate?.setUserProfile && this.delegate?.setUserProfile( profile, path, value )
  }

  getUserProfiles() {
    return this.delegate?.getUserProfiles && this.delegate?.getUserProfiles()
  }

  resetUserProfile( profile, path ) {
    return this.delegate?.resetUserProfile && this.delegate?.resetUserProfile( profile, path )
  }
  // end interface functions for a user's specific profile

  // user version stuff
  getUserVersion( state, path, version, opts ) {
    return this.delegate?.getVersion && this.delegate?.getVersion( state, path, version, opts )
  }

  getUserVersions( state, path, opts ) {
    return this.delegate?.getVersions && this.delegate?.getVersions( state, path, opts )
  }

  setUserVersion( path, version, value, opts ) {
    return this.delegate?.setVersion && this.delegate?.setVersion( path, version, value, opts )
  }

  renameUserVersion( path, oldVersionName, newVersionName, opts ) {
    return this.delegate?.renameVersion && this.delegate?.renameVersion( path, oldVersionName, newVersionName, opts )
  }

  resetUserVersion( path, version ) {
    return this.delegate?.resetVersion && this.delegate?.resetVersion( path, version )
  }
  // end user version stuff

  preloadAll() {
    return this.delegate?.preloadAll && this.delegate?.preloadAll()
  }
}

const instance = new UserSettings()

export default instance
